import { render, staticRenderFns } from "./settingsAccessMatrix.vue?vue&type=template&id=780ea2dc&scoped=true&"
import script from "./settingsAccessMatrix.vue?vue&type=script&lang=js&"
export * from "./settingsAccessMatrix.vue?vue&type=script&lang=js&"
import style0 from "./settingsAccessMatrix.vue?vue&type=style&index=0&id=780ea2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ea2dc",
  null
  
)

export default component.exports